interface CountItem {
  id: number | null;
  count: number;
}

export interface TagList {
  id: number;
  count: number;
  name: string;
}

export interface ReadingInfoList {
  id: number;
  count: number;
  name: string;
}

interface PersonInfo {
  id: number;
  count: number;
  imageId: number | null;
  name: string;
}

export interface MajorIdList {
  id: number | null;
  name: string;
  count: number;
}

export interface ReadingComprehensionCount {
  id: number;
  name: string;
  count: number;
}

interface PublisherBook {
  id: number;
  name: string;
}

export interface IFiltersInfo {
  tagList?: null | TagList[];
  bookmarkList?: null | any[];
  difficultyLevelList?: CountItem[];
  majorIdList?: MajorIdList[];
  originIdList?: CountItem[];
  examNoList?: CountItem[];
  personInfoList?: PersonInfo[];
  observedInfoList?: CountItem[];
  enabledInfoList?: CountItem[];
  questionTypeInfoList?: CountItem[];
  publisherBookInfo?: PublisherBook[];
  readingInfoList?: null | ReadingInfoList[];
}

export enum ExamDifficultyLevels {
  academic = 0,
  easy = 10,
  normal = 20,
  hard = 30,
  tooHard = 40
}

export interface ITopicsList {
  id: number;
}

export enum QuestionTypes {
  MULTIPLECHOICE = 10,
  READING_MULTIPLECHOICE = 20,
  EXPLANATORY = 30,
  READING_EXPLANATORY = 40
}
